/* Lampiero lv11 (10 Oct 2026). Every block guards itself; the words come from window.LV_T.v11 (snippets/lv-t, theme locale files).
   1. mouth tape way back: tape pages set a session flag; while it is set, the "Back to the mouth tape" pill under the header shows
      on the home page only (11 Oct: lamp pages and the cart always stay on the lamp)
   2. the 4+ lamps stepper: Kaching's own input and buttons stay the engine (prices stay Kaching's); this restyles and labels them,
      read-only number, 4 to 12, a line that changes with the number, "You save", aria (audit-ux section 2)
   3. "Free express shipping" under the 2, 3 and 4+ rows of every buy box (audit-ux P2-2) */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var T = w.LV_T || {}, V = T.v11 || {};
  var ROOT = typeof V.root === 'string' ? V.root : '';
  function safe(fn) { try { fn(); } catch (e) { if (w.console) console.warn('lv11', e); } }
  function each(sel, fn, r) { [].forEach.call((r || d).querySelectorAll(sel), function (el, i) { try { fn(el, i); } catch (e) { if (w.console) console.warn('lv11', sel, e); } }); }
  /* class changes only when needed: a no-op classList call still counts as a mutation and would wake the observers */
  function cls(x, c, on) { if (x && x.classList.contains(c) !== !!on) x.classList.toggle(c, !!on); }
  function el(tag, cls) { var x = d.createElement(tag); if (cls) x.className = cls; return x; }
  var TPL = (d.body && d.body.getAttribute('data-lv-t')) || '';

  /* 1. mouth tape way back */
  var TAPE_T = ['product.night-strip', 'page.two-sides-of-the-bed', 'page.yes-i-tape-my-mouth'];
  var onTape = TAPE_T.indexOf(TPL) > -1;
  function flag(v) { try { if (v) sessionStorage.setItem('lv-tape', '1'); return sessionStorage.getItem('lv-tape') === '1'; } catch (e) { return false; } }
  safe(function () {
    var tape = flag(onTape);
    var inCart = !!d.querySelector('[data-lv11-tape-cart]');
    /* 11 Oct (William): the way back to the mouth tape shows on the home page only; lamp pages and the cart stay on the lamp */
    if ((tape || inCart) && TPL.indexOf('index') === 0) each('[data-lv11-tapeback]', function (a) { a.hidden = false; });
  });

  /* 2 + 3. Kaching rows */
  function lamps(q) { return w.lv9Lamps ? w.lv9Lamps(q) : q + ' lamps'; }
  function money(t) { return w.lvMoney ? w.lvMoney.parse(String(t || '').replace(/[^\d.,\s  ]/g, '').trim()) : parseFloat(String(t || '').replace(/[^\d]/g, '')); }
  function cur(t) { t = String(t || ''); return /zł/.test(t) ? 'PLN' : /Kč/.test(t) ? 'CZK' : /€/.test(t) ? 'EUR' : null; }
  function fmt(n, t) { var c = cur(t), o = c && w.lvMoney && w.lvMoney.fmt(Math.round(n), c); return o || String(Math.round(n)); }
  function rangeLine(q) {
    if (q >= 12) return null;
    if (q >= 10) return V.step_10; if (q >= 7) return V.step_7; if (q >= 5) return V.step_5; return V.step_4;
  }
  var MAX = 12, MIN = 4;
  var btnOrig = null;

  function express(bar, i) {
    var left = bar.querySelector('.kaching-bundles__bar-content-left');
    if (!left) return;
    var x = left.querySelector('.lv11-kexp');
    if (i < 1 || !V.free_express) { if (x) x.parentNode.removeChild(x); return; }
    if (!x) { x = el('span', 'lv11-kexp'); x.setAttribute('data-wg-notranslate', ''); }
    if (x.textContent !== V.free_express) x.textContent = V.free_express;
    /* always the last line of the row, under the per-lamp or "You save" line */
    if (left.lastElementChild !== x) left.appendChild(x);
  }

  function stepper(bar) {
    var qs = bar.querySelector('.kaching-bundles__quantity-selector');
    var wrap = bar.querySelector('.kaching-bundles__bar-wrapper');
    var left = bar.querySelector('.kaching-bundles__bar-content-left');
    var save = left && left.querySelector('.lv11-ksave');
    if (!qs || !wrap) {
      each('.lv11-qdiv,.lv11-qhead,.lv11-qline', function (x) { x.parentNode.removeChild(x); }, bar);
      if (save) save.parentNode.removeChild(save);
      cls(wrap, 'lv11-qwrap', false);
      return 0;
    }
    cls(wrap, 'lv11-qwrap', true);
    var inp = qs.querySelector('input');
    var btns = qs.querySelectorAll('.kaching-bundles__quantity-selector__button');
    var minus = btns[0], plus = btns[btns.length - 1];
    var q = inp ? parseInt(inp.value, 10) : MIN; if (!q || q < MIN) q = MIN;
    if (inp) {
      if (!inp.readOnly) inp.readOnly = true;
      if (inp.getAttribute('inputmode') !== 'none') inp.setAttribute('inputmode', 'none');
      if (inp.getAttribute('max') !== String(MAX)) inp.setAttribute('max', String(MAX));
      if (V.how_many && inp.getAttribute('aria-label') !== V.how_many) inp.setAttribute('aria-label', V.how_many);
      if (inp.tabIndex !== -1) inp.tabIndex = -1;
    }
    if (minus && V.fewer && minus.getAttribute('aria-label') !== V.fewer) minus.setAttribute('aria-label', V.fewer);
    if (plus && V.more && plus.getAttribute('aria-label') !== V.more) plus.setAttribute('aria-label', V.more);
    if (minus) { var mOff = q <= MIN; cls(minus, 'lv11-off', mOff); minus.setAttribute('aria-disabled', mOff ? 'true' : 'false'); if (minus.tabIndex !== 0) minus.tabIndex = 0; }
    if (plus) { var pOff = q >= MAX; cls(plus, 'lv11-off', pOff); plus.setAttribute('aria-disabled', pOff ? 'true' : 'false'); if (plus.tabIndex !== 0) plus.tabIndex = 0; }
    /* divider and label on the line of the stepper */
    var div = wrap.querySelector('.lv11-qdiv'), head = wrap.querySelector('.lv11-qhead'), line = wrap.querySelector('.lv11-qline');
    if (!div) { div = el('div', 'lv11-qdiv'); div.setAttribute('aria-hidden', 'true'); }
    if (!head) { head = el('div', 'lv11-qhead'); head.setAttribute('aria-hidden', 'true'); }
    if (head.textContent !== (V.how_many || '')) head.textContent = V.how_many || '';
    if (div.nextSibling !== head || head.nextSibling !== qs) { qs.parentNode.insertBefore(div, qs); qs.parentNode.insertBefore(head, qs); }
    /* the line under the stepper changes with the number */
    if (!line) { line = el('p', 'lv11-qline'); line.setAttribute('data-wg-notranslate', ''); }
    var key = q >= MAX ? 'max' : String(rangeLine(q));
    if (line.getAttribute('data-k') !== key) {
      line.setAttribute('data-k', key);
      line.textContent = '';
      if (q >= MAX) {
        line.appendChild(d.createTextNode((V.more_12 || '') + ' '));
        var a = el('a'); a.href = ROOT + '/pages/contact'; a.textContent = V.write_us || ''; line.appendChild(a);
      } else line.textContent = rangeLine(q) || '';
    }
    if (qs.nextSibling !== line) qs.parentNode.insertBefore(line, qs.nextSibling);
    /* price: read out when it changes, and a short fade so the new total is noticed */
    var price = bar.querySelector('.kaching-bundles__bar-price'), was = bar.querySelector('.kaching-bundles__bar-full-price');
    if (price) {
      if (price.getAttribute('aria-live') !== 'polite') price.setAttribute('aria-live', 'polite');
      if (bar.__lv11q && bar.__lv11q !== q) { price.classList.remove('lv11-fade'); void price.offsetWidth; price.classList.add('lv11-fade'); }
    }
    bar.__lv11q = q;
    /* "You save" in the per-lamp line's style: crossed total minus price */
    if (left && price && was) {
      var pn = money(price.textContent), wn = money(was.textContent), txt = '';
      if (pn > 0 && wn > pn) txt = (T.you_save || 'You save') + ' ' + fmt(wn - pn, price.textContent);
      if (!save) { save = el('span', 'lv11-ksave'); save.setAttribute('data-wg-notranslate', ''); }
      if (save.textContent !== txt) save.textContent = txt;
      var kl = left.querySelector('.lv8-kline');
      if (kl && kl.nextSibling !== save) left.insertBefore(save, kl.nextSibling);
      else if (!kl && save.parentNode !== left) left.appendChild(save);
    }
    return q;
  }

  /* the room picker card above the rows reads "9 lamps" too */
  function pickTitle(q) {
    each('.lv6-pick__opt[data-lv-set="4"] .lv6-pick__n', function (n) { var t = lamps(q > MIN ? q : MIN); if (n.textContent !== t) n.textContent = t; });
  }
  /* the add to cart button follows the set while the 4+ row is chosen: "Add 6 lamps to cart · €270" */
  function buyLabel(q, bar) {
    var b = d.querySelector('.product-form__submit'), sp = b && b.querySelector('span:not(.loading__spinner)');
    if (!sp) return;
    if (btnOrig === null) btnOrig = sp.textContent.trim();
    var want = btnOrig;
    if (q && bar && V.add_n) {
      var p = bar.querySelector('.kaching-bundles__bar-price');
      want = V.add_n.replace('[lamps]', lamps(q)) + (p && p.textContent.trim() ? ' · ' + p.textContent.trim() : '');
    }
    if (sp.textContent.trim() !== want) sp.textContent = want;
  }

  function tidy() {
    var kb = d.querySelector('kaching-bundles-block'); if (!kb || d.querySelector('[data-nt-bb]')) return;
    var bars = kb.querySelectorAll('.kaching-bundles__bar'), q4 = 0, sel4 = null;
    [].forEach.call(bars, function (bar, i) {
      if (i > 3) return;
      safe(function () { express(bar, i); });
      if (i === 3) safe(function () { q4 = stepper(bar); if (q4 && bar.classList.contains('kaching-bundles__bar--selected')) sel4 = bar; });
    });
    safe(function () { pickTitle(sel4 ? q4 : MIN); });
    safe(function () { buyLabel(sel4 ? q4 : 0, sel4); });
  }

  /* the plus button stops at 12 (Kaching has no maximum); the minus at 4 is Kaching's own */
  function guard(e) {
    var b = e.target.closest && e.target.closest('.kaching-bundles__quantity-selector__button');
    if (!b) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var qs = b.parentNode, inp = qs.querySelector('input'), btns = qs.querySelectorAll('.kaching-bundles__quantity-selector__button');
    var q = inp ? parseInt(inp.value, 10) : 0;
    if (b === btns[btns.length - 1] && q >= MAX) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    else if (e.type === 'keydown') { e.preventDefault(); e.stopPropagation(); b.click(); }
  }
  d.addEventListener('click', guard, true);
  d.addEventListener('keydown', guard, true);

  var tries = 0, busy = false;
  (function init() {
    var kb = d.querySelector('kaching-bundles-block');
    if (!kb || !kb.querySelector('.kaching-bundles__bar')) { if (tries++ < 80) setTimeout(init, 250); return; }
    if ('MutationObserver' in w) new MutationObserver(function () {
      if (busy) return; busy = true;
      setTimeout(function () { busy = false; safe(tidy); }, 40);
    }).observe(kb, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    safe(tidy); [400, 1500, 4000].forEach(function (t) { setTimeout(function () { safe(tidy); }, t); });
  })();

  /* pack1 (19 Oct): lv11.css keeps room for the Kaching rows on phones; if the rows have not appeared 15 s after the page is
     ready (app blocked or failed), the room is given back so no empty space stays above the buy button */
  setTimeout(function () { safe(function () { if (!d.querySelector('kaching-bundles-block .kaching-bundles__bar')) cls(html, 'lv-nok', true); }); }, 15000);
})();

/* v11.4 (19 Oct 2026): the light switch and the before/after sliders swap between pictures; on a phone a picture that has
   not loaded yet shows as a black frame. All their pictures start loading 1,200 px before the block is on screen. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (!en.isIntersecting) return; io.unobserve(en.target); [].forEach.call(en.target.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; }); });
  }, { rootMargin: '1200px 0px' });
  [].forEach.call(document.querySelectorAll('[data-lv-sw], [data-lv-ba], [data-lv-ba-sweep]'), function (el) { io.observe(el); });
})();
